import React, { Component } from "react";
import { Select } from "antd";
import axios from "axios";
import SelectItem from "./SelectItem";

const { Option } = Select;

class SelectMarcasItem extends Component {
  state = { opciones: [], cargando: false };

  componentDidMount() {
    this.cargarOpciones();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.empresaId !== this.props.empresaId) {
      this.cargarOpciones();
    }
  }

  cargarOpciones = () => {
    const { headersToken, empresaId } = this.props;
    if (!empresaId) return;
    this.setState({ cargando: true });
    axios
      .post("marcas/selectMarcas", { empresaId }, { headers: headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ opciones: res.data.marcas || [] });
        }
      })
      .catch(() => {})
      .finally(() => this.setState({ cargando: false }));
  };

  render() {
    const { value, onChange, placeholder, style, width, disabled, mode, allowClear } = this.props;
    const { opciones, cargando } = this.state;

    return (
      <SelectItem
        placeholder={placeholder ?? "Marca"}
        width={width}
        style={style}
        mode={mode}
        allowClear={allowClear ?? true}
        disabled={disabled}
        value={value}
        onChange={onChange}
        mostrarCarga
        loading={cargando}
        noFocusSiguiente={this.props.noFocusSiguiente ?? true}
      >
        {opciones.map((m) => (
          <Option key={m._id} value={m._id}>
            {m.nombre}
          </Option>
        ))}
      </SelectItem>
    );
  }
}

export default SelectMarcasItem;
